import React, { Fragment, useState, useEffect, useRef } from 'react';
import PaymentMethodSelector from '../../shared/PaymentMethodSelector';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import { CircularProgress, Divider, FormHelperText } from '@mui/material';
import { Button } from '@mui/material';
import ReCAPTCHA from 'react-google-recaptcha';
import OutlinedInput from '@mui/material/OutlinedInput';
import { getData, postData } from '../../services/fetch-service';
import { useFormik } from 'formik';
import * as Yup from 'yup'
import { setPaymentResponse } from '../store/dataslice';
import PayseraPayment from '../PayseraPayment';
import dayjs from 'dayjs';
import { FaEuroSign } from 'react-icons/fa';
import { LoadingOverlay, Loader } from '@mantine/core';
import Swal from 'sweetalert2';

const customLoader = (
    <div className="payment-load">
        <Loader color="#006" />
        <span>Në procesim...</span>
    </div>
);

const KruHidroregjinoiJugor_PaymentFields = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const reCaptchaRef = useRef(null);
    const [updateLoader, setUpdateLoader] = useState(false);

    const SelectedPayment = useSelector((state) => state.Website.data.PaymentSelected);
    const [NumriSerik, setNumriSerik] = useState(null);
    const [InstitucioniServiceData, setInstitucioniServiceData] = useState(null);
    const [kerkoLoading, setKerkoLoading] = useState(false);
    const [pagesaLoading, setPagesaLoading] = useState(false);
    const [loanLoading, setLoanLoading] = useState(false);
    const [shumaValue, setShumaValue] = useState(null);
    const [Loan, setLoan] = useState(false);
    const [paymentMethodCode, setPaymentMethodCode] = useState("wallet");

    // const fetchInstitucioniServiceData = async (token) => {
    //     try {
    //         const response = await getData(`Pagesat/GetInstitucionServiceData?llojipagesesID=1015&serialNumber=${NumriSerik}&token=${token}`);
    //         setInstitucioniServiceData(response.data.respond);
    //         setKerkoLoading(false);
    //     } catch (error) {
    //         setKerkoLoading(false);
    //         setInstitucioniServiceData(null);
    //         Swal.fire({
    //             icon: 'error',
    //             title: 'Gabim',
    //             text: "Pagesa me këtë shifër nuk është gjetur!"
    //         });
    //     }
    // };

    const fetchInstitucioniServiceData = async (token) => {
        try {
            const response = await postData('Pagesat/GetInstitucionServiceData', {
                llojipagesesID: 1015,
                serialNumber: NumriSerik,
                token: token
            });
            if (response) {
                setInstitucioniServiceData(response.data.respond);
                setKerkoLoading(false);
            }
        } catch (error) {
            setKerkoLoading(false);
            setInstitucioniServiceData(null);
            Swal.fire({
                icon: 'error',
                title: 'Gabim',
                text: "Pagesa me këtë shifër nuk është gjetur!"
            });
        }
    };

    const handleShumaChange = (event) => {
        setShumaValue(event.target.value);
        formik.setFieldValue('shuma', event.target.value)
    };

    async function handleSearch() {
        reCaptchaRef.current.reset();
        try {
            setKerkoLoading(true);
            const token = await reCaptchaRef.current.executeAsync();
            fetchInstitucioniServiceData(token);
        } catch (error) {
            setKerkoLoading(true);
        }
    };

    const handlePaymentMethodCode = (event) => {
        setPaymentMethodCode(event.target.value);
    };

    const clickPaymentMethodCode = (value) => {
        setPaymentMethodCode(value);
    };

    const handleBack = () => {
        navigate('/');
    }

    const payment_validationSchema = Yup.object().shape({
        Email: Yup.string().email('Email nuk është valid!').required('Email është obligativ!'),
        shuma: Yup.string().required('Shuma është obligative!'),
    });

    const formik = useFormik({
        initialValues: {
            Email: '',
            shuma: null,
        },
        validationSchema: payment_validationSchema,
        onSubmit: (values) => {
            reCaptchaRef.current.reset();
            postPagesaPerSherbime(values)
        },
    });

    const today = new Date();
    const strDataPageses = dayjs(today).format('DD/MM/YYYY');

    const postPagesaPerSherbime = async (data) => {
        const token = await reCaptchaRef.current.executeAsync();
        try {
            setUpdateLoader(true);
            const newData = {
                ...data,
                emri: InstitucioniServiceData.name,
                mbiemri: '/',
                institucioniId: 138,
                provizioni: 0,
                viti: `${new Date().getFullYear()}`,
                strProvizioni: '0',
                llojiPagesesID: 1015,
                numriSerik: NumriSerik,
                numriUnikPageses: InstitucioniServiceData.referenceNumber,
                strDataPageses: `${strDataPageses}`,
                strVlera: `${shumaValue}`,
                strVleraTotale: `${shumaValue}`,
                pershkrimi: 'Pagesë për KRU Hidroregjioni Jugor',
                paymentMethod: 3,
                sherbimiTipiID: 7,
                unirefOK: false,
                token: token,
                PaymentMethodCode: paymentMethodCode
            }
            const response = await postData('Pagesat/PagesaPerSherbime', newData);
            if (response && response.status === 200) {
                // if (!Loan && paymentMethodCode !== 'visa') {
                //     dispatch(setPaymentResponse(response.data.respond));
                //     setPagesaLoading(false);
                // } else {
                //     setLoanLoading(false);
                //     const paymentWindow = window.open('', '_self');
                //     paymentWindow.location.href = `${response.data.link}`;
                // }
                setLoanLoading(false);
                setPagesaLoading(false);
                setUpdateLoader(false);
                const paymentWindow = window.open('', '_self');
                paymentWindow.location.href = `${response.data.link}`;
            }
        } catch (error) {
            setPagesaLoading(false);
            setLoanLoading(false);
            setUpdateLoader(false);
            // console.log('error', error)
            Swal.fire({
                icon: 'error',
                title: 'Gabim',
                text: `${error.response ? error.response.data.modelState.Error.errors[0].errorMessage : "Pagesa dështoi!"}`
            });
        }
    }

    useEffect(() => {
        const AmountForPayment = parseFloat(InstitucioniServiceData && InstitucioniServiceData.debtAmount);
        setShumaValue(AmountForPayment);
        formik.setFieldValue('shuma', AmountForPayment);
    }, [InstitucioniServiceData]);

    const handlePayProcess = () => {
        if (paymentMethodCode === "PaySeraKredi") {
            handlePayWithLoan();
        } else {
            handlePay();
        }
    }

    const handlePay = () => {
        formik.validateForm().then((errors) => {
            if (Object.keys(errors).length === 0) {
                setPagesaLoading(true);
                formik.handleSubmit();
            } else {
                formik.setTouched(Object.keys(formik.values).reduce((acc, key) => {
                    acc[key] = true;
                    return acc;
                }, {}));
            }
        });
    }

    const handlePayWithLoan = () => {
        formik.validateForm().then((errors) => {
            if (Object.keys(errors).length === 0) {
                setLoanLoading(true);
                setLoan(true);
                formik.handleSubmit();
            } else {
                formik.setTouched(Object.keys(formik.values).reduce((acc, key) => {
                    acc[key] = true;
                    return acc;
                }, {}));
            }
        });
    }

    return (
        <div className="paysera-home paysera-feilds">
            <div className="home-header">
                <h1 className='headline-font'>
                    {SelectedPayment.description}
                </h1>
            </div>
            <div className="paysera-form-body">
                <div className="form-box search-box">
                    <div className="form-body search-body">
                        <div className="paysera-form search-s">
                            <div className="paysera-inputLabel s-Label">
                                <label htmlFor="Numri Serik">Kërko përmes Kodit <span className="required">*</span></label>
                                <div className="s-input">
                                    <OutlinedInput
                                        size="small"
                                        id="outlined-adornment-input"
                                        placeholder="Kodi"
                                        aria-describedby="outlined-input-helper-text"
                                        inputProps={{
                                            'aria-label': 'input',
                                        }}
                                        onChange={(event) => setNumriSerik(event.target.value)}
                                        onKeyPress={(event) => {
                                            if (event.key === 'Enter' && NumriSerik !== null) {
                                                handleSearch();
                                            }
                                        }}
                                    />
                                    <Button
                                        type="button"
                                        className="dynamic-button"
                                        variant="contained"
                                        onClick={handleSearch}
                                        disabled={kerkoLoading || (NumriSerik === null)}
                                    // startIcon={kerkoLoading && <CircularProgress size={20} color="inherit" />}
                                    >
                                        {kerkoLoading ? <CircularProgress size={24} /> : 'Kërko'}
                                    </Button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="form-box">
                    <Divider className='subheading-font' textAlign="center">Detajet e pagesës</Divider>
                    <div className="form-body">
                        {InstitucioniServiceData ? (
                            <div className="paysera-form">
                                <div className="paysera-inputLabel">
                                    <label htmlFor="Konsumatori">Konsumatori</label>
                                    <OutlinedInput
                                        size="small"
                                        id="outlined-adornment-input"
                                        placeholder="Konsumatori"
                                        disabled
                                        type="text"
                                        value={InstitucioniServiceData.name}
                                        aria-describedby="outlined-input-helper-text"
                                        inputProps={{
                                            'aria-label': 'input',
                                        }}
                                    />
                                </div>
                                <div className="paysera-inputLabel">
                                    <label htmlFor="Adresa">Adresa</label>
                                    <OutlinedInput
                                        size="small"
                                        id="outlined-adornment-input"
                                        placeholder="Adresa"
                                        disabled
                                        type="text"
                                        value={InstitucioniServiceData.address}
                                        aria-describedby="outlined-input-helper-text"
                                        inputProps={{
                                            'aria-label': 'input',
                                        }}
                                    />
                                </div>
                                <div className="paysera-inputLabel">
                                    <label htmlFor="Numri Telefonit">Numri Telefonit</label>
                                    <OutlinedInput
                                        size="small"
                                        id="outlined-adornment-input"
                                        placeholder="Numri Telefonit"
                                        disabled
                                        type="text"
                                        value={InstitucioniServiceData.phoneNumber}
                                        aria-describedby="outlined-input-helper-text"
                                        inputProps={{
                                            'aria-label': 'input',
                                        }}
                                    />
                                </div>
                                <div className="paysera-inputLabel">
                                    <label htmlFor="Territori">Territori</label>
                                    <OutlinedInput
                                        size="small"
                                        id="outlined-adornment-input"
                                        placeholder="Territori"
                                        disabled
                                        type="text"
                                        value={InstitucioniServiceData.territoryCode}
                                        aria-describedby="outlined-input-helper-text"
                                        inputProps={{
                                            'aria-label': 'input',
                                        }}
                                    />
                                </div>
                                <div className="paysera-inputLabel">
                                    <label htmlFor="Numri Referencës">Numri Referencës</label>
                                    <OutlinedInput
                                        size="small"
                                        id="outlined-adornment-input"
                                        placeholder="Numri Referencës"
                                        disabled
                                        type="text"
                                        value={InstitucioniServiceData.referenceNumber}
                                        aria-describedby="outlined-input-helper-text"
                                        inputProps={{
                                            'aria-label': 'input',
                                        }}
                                    />
                                </div>
                                <div className="paysera-inputLabel">
                                    <label htmlFor="Kategoria">Kategoria</label>
                                    <OutlinedInput
                                        size="small"
                                        id="outlined-adornment-input"
                                        placeholder="Kategoria"
                                        disabled
                                        type="text"
                                        value={InstitucioniServiceData.categoryCode}
                                        aria-describedby="outlined-input-helper-text"
                                        inputProps={{
                                            'aria-label': 'input',
                                        }}
                                    />
                                </div>
                                <div className="paysera-inputLabel">
                                    <label htmlFor="Borxhi mbetur">Borxhi mbetur</label>
                                    <OutlinedInput
                                        size="small"
                                        id="outlined-adornment-input"
                                        placeholder="Borxhi mbetur"
                                        disabled
                                        type="text"
                                        value={InstitucioniServiceData.debtAmount}
                                        aria-describedby="outlined-input-helper-text"
                                        inputProps={{
                                            'aria-label': 'input',
                                        }}
                                    />
                                </div>
                                <div className="paysera-inputLabel">
                                    <label className={formik.touched.Email && formik.errors.Email ? 'label-top' : ''} htmlFor="Numri Serik">Email <span className="required">*</span></label>
                                    <div className="input">
                                        <OutlinedInput
                                            size="small"
                                            id="outlined-adornment-input"
                                            placeholder="Shëno email-in tuaj"
                                            name='Email'
                                            type="email"
                                            aria-describedby="outlined-input-helper-text"
                                            inputProps={{
                                                'aria-label': 'input',
                                            }}
                                            value={formik.values.Email}
                                            onChange={formik.handleChange}
                                            onBlur={formik.handleBlur}
                                            error={formik.touched.Email && formik.errors.Email}
                                        />
                                        {
                                            (formik.touched.Email && formik.errors.Email) &&
                                            (
                                                <FormHelperText>{formik.errors.Email}</FormHelperText>
                                            )
                                        }
                                    </div>
                                </div>
                                <div className="paysera-inputLabel">
                                    <label className={formik.touched.shuma && formik.errors.shuma ? 'label-top' : ''} htmlFor="Shuma për pagesë">
                                        Shuma për pagesë <span className="required">*</span>
                                    </label>
                                    <div className="input">
                                        <OutlinedInput
                                            // disabled
                                            size="small"
                                            id="outlined-adornment-input"
                                            type='number'
                                            className='number-input'
                                            placeholder="Shuma për pagesë"
                                            aria-describedby="outlined-input-helper-text"
                                            value={shumaValue}
                                            endAdornment={<FaEuroSign />}
                                            onChange={handleShumaChange}
                                            inputProps={{
                                                'aria-label': 'input',
                                            }}
                                            onBlur={formik.handleBlur}
                                            error={formik.touched.shuma && formik.errors.shuma}
                                        />
                                        {
                                            (formik.touched.shuma && formik.errors.shuma) &&
                                            (
                                                <FormHelperText>{formik.errors.shuma}</FormHelperText>
                                            )
                                        }
                                    </div>
                                </div>
                                <PaymentMethodSelector
                                    paymentMethodCode={paymentMethodCode}
                                    onPaymentMethodChange={handlePaymentMethodCode}
                                    onPaymentMethodClick={clickPaymentMethodCode}
                                />
                                <div className="p-buttons">
                                    <div className="payForm-btn">
                                        <Button type="button" variant="outlined" onClick={handleBack}>
                                            Kthehu
                                        </Button>
                                        {/* <Button
                                            id="payNow"
                                            type="button"
                                            variant="contained"
                                            onClick={handlePayWithLoan}
                                            // disabled
                                            disabled={loanLoading}
                                            startIcon={loanLoading && <CircularProgress size={20} color="inherit" />}
                                        >
                                            {loanLoading ? 'Loading...' : 'Paguaj përmes kredisë'}
                                        </Button> */}
                                        <Button
                                            id="payNow"
                                            type="button"
                                            variant="contained"
                                            onClick={handlePayProcess}
                                            disabled={pagesaLoading}
                                            startIcon={pagesaLoading && <CircularProgress size={20} color="inherit" />}
                                        >
                                            {pagesaLoading ? 'Duke paguar...' : 'Paguaj'}
                                        </Button>
                                    </div>
                                </div>
                            </div>
                        ) : (
                            <Fragment>
                                <div className="skeletonBox-detajet">
                                    <h4 className="skeleton-title-font" >Për të shfaqur detajet e pagesës kërkoni përmes kodit.</h4>
                                </div>
                                <div className="skeleton-btn">
                                    <Button type="button" variant="outlined" onClick={handleBack}>
                                        Kthehu
                                    </Button>
                                </div>
                            </Fragment>
                        )}
                    </div>

                </div>
            </div>
            <ReCAPTCHA
                badge="bottomleft"
                sitekey={process.env.REACT_APP_SITE_KEY}
                size="invisible"
                ref={reCaptchaRef}
            />
            <PayseraPayment />
            <LoadingOverlay loader={customLoader} visible={updateLoader} />
        </div>
    )
}

export default KruHidroregjinoiJugor_PaymentFields